import configure from './configure';
import isChromatic from './isChromatic';

configure();

// eslint-disable-next-line import/prefer-default-export
export { isChromatic };
